import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { Customer } from '../../../../models/Customer';
import { ContactInformation } from '../../../../models/ContacInformation';
import { Button } from '../../../../models/Button';
import { Router } from '@angular/router';
import { Setting } from '../../../../models/Setting';
import { SettingService } from '../../../../services/setting.service';
import { SettingValuePipe } from '../../../../pipes/setting-value.pipe';
import { TranslatePipe } from '@ngx-translate/core';
import { Treatment } from '../../../../models/Treatment';
import { TreatmentService } from '../../../../services/treatment.service';
import { CustomerService } from '../../../../services/customer.service';
import { ButtonDirective } from 'primeng/button';

const TREATMENT_STATUS_IN_PROGRESS = 1;

@Component({
  selector: 'app-customer',
  templateUrl: './customer.component.html',
  styleUrls: ['./customer.component.scss'],

  imports: [SettingValuePipe, TranslatePipe, ButtonDirective]
})
export class CustomerComponent implements OnInit, OnChanges {
  public customerButton: Button;
  public customerContactInfo: ContactInformation | null = null;
  public partner: Customer | null = null;
  public partnerContactInfo: ContactInformation | null = null;
  public genderSettings: Array<Setting>;
  public latestInProgressTreatment: Treatment | null = null;
  @Input() customer: Customer | null = null;
  constructor(
    private router: Router,
    private settingsService: SettingService,
    private treatmentService: TreatmentService,
    private customerService: CustomerService
  ) {
    this.customerButton = new Button();
    this.customerButton.icon = 'pi pi-user-edit';
    this.customerButton.styleClass =
      'p-button-rounded p-button-outlined p-button-info p-ml-2';
    this.customerButton.id = 'edit';
    this.genderSettings = new Array<Setting>();
  }

  async ngOnInit(): Promise<void> {
    this.genderSettings = await this.settingsService.getSettingByName('GENDER');
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.customer = null;
    this.latestInProgressTreatment = null;
    if (changes.customer) {
      this.customer = changes.customer.currentValue;
      if (this.customer!.contactInfo) {
        this.customerContactInfo = this.customer!.contactInfo;
      }
      if (this.customer!.partner) {
        this.partner = this.customer!.partner;
        if (this.partner?.contactInfo) {
          this.partnerContactInfo = this.partner.contactInfo;
        }
      }
      this.treatmentService
        .getCustomerTreatments(this.customer!.id)
        .subscribe((treatments) => {
          this.latestInProgressTreatment =
            (treatments || [])
              .filter((t) => t.status === TREATMENT_STATUS_IN_PROGRESS)
              .sort(
                (a, b) =>
                  new Date(b.treatmentStartDate || 0).getTime() -
                  new Date(a.treatmentStartDate || 0).getTime()
              )[0] || null;
        });
    }
  }
  /**
   * Opens the Plan step of the given treatment cycle. The treatment module's
   * TreatmentGuard only checks the currently selected customer (not the :id
   * in the URL), so the customer must be selected before navigating there.
   */
  async openTreatmentCycle(treatment: Treatment): Promise<void> {
    if (!this.customer) {
      return;
    }
    await this.customerService.setSelectedCustomer(this.customer);
    const base =
      this.customer.customerType === 'd' || this.customer.customerType === 'e'
        ? 'donor'
        : 'customer';
    await this.router.navigate([
      `/${base}/treatments/treatment/`,
      treatment.id,
      'plan'
    ]);
  }

  editCustomer(customer: Customer): void {
    if (customer.customerType === 'd') {
      this.router.navigate(['donor/basic', customer.id]);
    } else if (customer.customerType === 'e') {
      this.router.navigate(['donor/external', customer.id]);
    } else {
      this.router.navigate(['customer/basic', customer.id]);
    }
  }
}
